import http from "@/http";

const LoteImportacaoService = {
  async getProjetosLote(filtros = {}) {
    try {
      const response = await http.get(
        "/api/astec/projetos/importarProjetos/getProjetosLote",
        {
          params: filtros
        }
      );

      const result = response.data;

      if (result.erro) {
        throw new Error(result.data || "Erro ao buscar projetos");
      }

      const dados = result.data;

      // Converter para o formato que o grid espera
      return {
        data: dados.dados || [],
        total: dados.total_registros || 0,
        current_page: dados.pagina_atual || 1,
        per_page: dados.itens_por_pagina || 10,
        last_page: dados.ultima_pagina || 1
      };
    } catch (error) {
      console.error("Erro ao buscar projetos do lote:", error);
      throw error;
    }
  }
};

export default LoteImportacaoService;
